<div class="paginate-page-select">
    <label class="table-header app-label-table">{{'paginate_items_per_page'| translation}}:</label>
    <p-select (onChange)="setPageCount()"  ngDefaultControl [placeholder]="'paginate_per_page'| translation"  [options]="perPageOptions" [(ngModel)]="perPage" optionLabel="count" optionValue="count"/>

  <div style="flex:1 1 auto;"></div>
  <div class="paginate-page-select-count-label" *ngIf="countLabel">
    {{ countLabel }}
  </div>
</div>
